<template>
  <el-dialog
    :title="isPrintMode ? '血氧报告打印预览' : '血氧报告预览'"
    :visible.sync="dialogVisible"
    width="85%"
    top="5vh"
    :before-close="handleClose"
    class="blood-oxygen-report-preview-dialog"
  >
    <div v-if="reportDetailModel" class="single-blood-oxygen-report" ref="imageDom">
      <!-- 打印时的固定页眉 - 包含完整头部信息 -->
      <div class="print-header">
        <section-report-header-print :reportDetailModel="reportDetailModel"></section-report-header-print>
      </div>
      
      <!-- 屏幕显示的头部信息 -->
      <div class="screen-header">
        <img class="single-blood-oxygen-report-logo" :src="reportDetailModel.sopReportLogo"
          :style="{ width: reportDetailModel.xyReportTemplateType === 3 ? '166px' : '66px' }"
          v-if="reportDetailModel.sopReportLogo != null && reportDetailModel.sopReportLogo != ''">
        <p class="single-blood-oxygen-report-title">{{ reportDetailModel.sopReportHeaders || "" }}</p>
        <p class="single-blood-oxygen-report-subtitle">{{ reportDetailModel.sopReportSubTitle || "" }}</p>
        <div class="single-blood-oxygen-report-button-container" :class="useClassWithDifferentBrower()">
          <button class="single-blood-oxygen-report-button-container-item noPrint" 
                  :disabled="true" 
                  @click="onShare">分享</button>
          <button class="single-blood-oxygen-report-button-container-item noPrint" 
                  :disabled="true" 
                  @click="onDownloadPNG">下载PNG</button>
          <button class="single-blood-oxygen-report-button-container-item noPrint" 
                  :disabled="true" 
                  @click="onDownloadPDF">下载PDF</button>
          <button class="single-blood-oxygen-report-button-container-item noPrint" 
                  :disabled="true" 
                  @click="onPrint">打印</button>
        </div>
        <section-time :reportDetailModel="reportDetailModel" v-if="showBasicInfo"></section-time>
        <section-user-info :reportDetailModel="reportDetailModel" 
                           @onEditUserInfoSucceed="onEditUserInfoSucceed" 
                           :isPreviewMode="true"
                           v-if="showBasicInfo">
        </section-user-info>
      </div>

      <!-- 第一页内容包装器 -->
      <div class="print-page-1" v-if="showFirstPage">
        <section-blood-oxygen 
          class="first-content-section" 
          :reportDetailModel="reportDetailModel"
          v-if="reportDetailModel.spo2PulseModuleConfig.includes('血氧统计')"
        ></section-blood-oxygen>
        <section-oxygen-minus-table 
          v-if="reportDetailModel.spo2PulseModuleConfig.includes('氧减统计')" 
          :reportDetailModel="reportDetailModel"
        ></section-oxygen-minus-table>
        <section-trend-chart-template1 
          v-if="reportDetailModel.spo2PulseModuleConfig.includes('血氧趋势')"
          :reportDetailModel="reportDetailModel"
        ></section-trend-chart-template1>
        <section-pulse 
          v-if="reportDetailModel.spo2PulseModuleConfig.includes('脉率统计')"
          :reportDetailModel="reportDetailModel"
        ></section-pulse>
        <section-pulse-trend-chart 
          v-if="reportDetailModel.spo2PulseModuleConfig.includes('脉率趋势图')"
          :reportDetailModel="reportDetailModel"
        ></section-pulse-trend-chart>
        <section-oxgen-monitoring-overview 
          v-if="reportDetailModel.spo2PulseModuleConfig.includes('血氧监测综述')"
          :reportDetailModel="reportDetailModel" 
          :isPreviewMode="true"
          @onEditSuggestionSucceed="onEditSuggestionSucceed"
        ></section-oxgen-monitoring-overview>
      </div>

      <!-- 第二页内容包装器 -->
      <div class="print-page-2">
        <!-- 睡眠分期统计 -->
        <div class="single-blood-oxygen-report-section sleep-content-section" v-if="reportDetailModel.sleepStructureModuleConfig.includes('睡眠时长概况')">
          <section-period-table :reportDetailModel="reportDetailModel"></section-period-table>
          <div class="single-blood-oxygen-report-section-chart">
            <section-period-chart :reportDetailModel="reportDetailModel"></section-period-chart>
            <section-time-period-chart :reportDetailModel="reportDetailModel"></section-time-period-chart>
          </div>
        </div>
        <section-trend-sleep-chart 
          v-if="reportDetailModel.sleepStructureModuleConfig.includes('睡眠分期图')"
          :reportDetailModel="reportDetailModel"
        ></section-trend-sleep-chart>
        <section-sleep-monitoring-overview 
          v-if="reportDetailModel.sleepStructureModuleConfig.includes('睡眠监测综述')"
          :reportDetailModel="reportDetailModel" 
          :isPreviewMode="true"
          @onEditSuggestionSucceed="onEditSuggestionSucceed"
        ></section-sleep-monitoring-overview>
        <section-suggestion 
          v-if="reportDetailModel.sleepStructureModuleConfig.includes('监测意见与建议')"
          :reportDetailModel="reportDetailModel" 
          :isPreviewMode="true"
          @onEditSuggestionSucceed="onEditSuggestionSucceed"
        ></section-suggestion>
      </div>

      <!-- 报告底部 -->
      <section-report-bottom v-if="reportDetailModel.isShowIntended()"></section-report-bottom>
    </div>
    <div v-else class="loading-content">
      <p>正在加载预览数据...</p>
    </div>
  </el-dialog>
</template>

<script>
import KeyValueUnit from "@c/report-detail/single-blood-oxygen-report/common/key-value-unit/key-value-unit-blood-oxygen-report.vue";
import SectionTime from "@c/report-detail/single-blood-oxygen-report/new-section/section-time.vue";
import SectionUserInfo from "@c/report-detail/single-blood-oxygen-report/new-section/section-user-info.vue";
import SectionReportHeaderPrint from "@c/report-detail/single-blood-oxygen-report/new-section/section-report-header-print.vue";
import SectionBloodOxygen from "@c/report-detail/single-blood-oxygen-report/new-section/section-blood-oxygen.vue";
import SectionOxygenMinusTable from "@c/report-detail/single-blood-oxygen-report/new-section/section-oxygen-minus-table.vue";
import SectionPulse from "@c/report-detail/single-blood-oxygen-report/new-section/section-pulse.vue";
import SectionHrv from "@c/report-detail/single-blood-oxygen-report/section-hrv.vue";
import SectionPeriod from "@c/report-detail/single-blood-oxygen-report/section-period.vue";
import SectionTrendChart from "@c/report-detail/single-blood-oxygen-report/section-trend-chart.vue";
import SectionTrendChartTemplate1 from "@c/report-detail/single-blood-oxygen-report/new-section/section-trend-chart-template1.vue";
import SectionBloodOxygenTable from "@c/report-detail/single-blood-oxygen-report/section-blood-oxygen-table.vue";
import SectionBloodOxygenChart from "@c/report-detail/single-blood-oxygen-report/section-blood-oxygen-chart.vue";
import SectionOxygenMinusEventTable from "@c/report-detail/single-blood-oxygen-report/section-oxygen-minus-event-table.vue";
import SectionOxygenMinusEventChart from "@c/report-detail/single-blood-oxygen-report/section-oxygen-minus-event-chart.vue";
import SectionOxygenMinusTimeTable from "@c/report-detail/single-blood-oxygen-report/section-oxygen-minus-time-table.vue";
import SectionOxygenMinusTimeChart from "@c/report-detail/single-blood-oxygen-report/section-oxygen-minus-time-chart.vue";
import SectionPeriodTable from "@c/report-detail/single-blood-oxygen-report/new-section/section-period-table.vue";
import SectionPeriodChart from "@c/report-detail/single-blood-oxygen-report/new-section/section-period-chart.vue";
import SectionTimePeriodChart from "@c/report-detail/single-blood-oxygen-report/new-section/section-time-period-chart.vue";
import SectionSuggestion from "@c/report-detail/single-blood-oxygen-report/new-section/section-suggestion.vue";
import SectionOxgenMonitoringOverview from "@c/report-detail/single-blood-oxygen-report/new-section/section-oxgen-monitoring-overview.vue";
import SectionSleepMonitoringOverview from "@c/report-detail/single-blood-oxygen-report/new-section/section-sleep-monitoring-overview.vue";
import SectionTrendSleepChart from "@c/report-detail/single-blood-oxygen-report/new-section/section-trend-sleep-chart.vue";
import SectionPulseTrendChart from "@c/report-detail/single-blood-oxygen-report/new-section/section-pulse-trend-chart.vue";
import SectionReportBottom from "@c/report-detail/single-blood-oxygen-report/section-report-bottom.vue";
import { ReportDetailModel } from "@c/report-detail/single-blood-oxygen-report/report-detail-model.js";
import { ReportPreviewTool } from "@js/report-preview-tool.js";
import html2canvas from "html2canvas";
import { DateTool } from "@js/date-tool.js";
import deviceTool from "@js/deviceTool.js"
import appHandler from "@js/appHandler.js"
import { MessageBox } from 'element-ui';

export default {
  name: 'BloodOxygenReportPreviewDialog',
  
  components: {
    KeyValueUnit,
    SectionTime,
    SectionUserInfo,
    SectionBloodOxygen,
    SectionOxygenMinusTable,
    SectionHrv,
    SectionPulse,
    SectionPeriod,
    SectionTrendChart,
    SectionTrendChartTemplate1,
    SectionBloodOxygenTable,
    SectionBloodOxygenChart,
    SectionOxygenMinusEventTable,
    SectionOxygenMinusEventChart,
    SectionOxygenMinusTimeTable,
    SectionOxygenMinusTimeChart,
    SectionPeriodTable,
    SectionPeriodChart,
    SectionSuggestion,
    SectionReportBottom,
    SectionOxgenMonitoringOverview,
    SectionTimePeriodChart,
    SectionTrendSleepChart,
    SectionPulseTrendChart,
    SectionSleepMonitoringOverview,
    SectionReportHeaderPrint,
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    reportId: {
      type: [String, Number],
      default: ''
    },
    isPrintMode: {
      type: Boolean,
      default: false
    },
    configData: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      reportDetailModel: undefined
    };
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    
    // 判断是否显示第一页（血氧相关内容）
    showFirstPage() {
      if (!this.reportDetailModel?.spo2PulseModuleConfig) return false;
      
      return this.reportDetailModel.spo2PulseModuleConfig.includes('血氧统计') || 
             this.reportDetailModel.spo2PulseModuleConfig.includes('氧减统计') ||
             this.reportDetailModel.spo2PulseModuleConfig.includes('血氧趋势') ||
             this.reportDetailModel.spo2PulseModuleConfig.includes('脉率统计') ||
             this.reportDetailModel.spo2PulseModuleConfig.includes('脉率趋势图') ||
             this.reportDetailModel.spo2PulseModuleConfig.includes('血氧监测综述');
    },

    // 判断是否显示基本信息模块（时间和用户信息）
    showBasicInfo() {
      const spo2HasBasicInfo = this.reportDetailModel?.spo2PulseModuleConfig?.includes('基本信息');
      const sleepHasBasicInfo = this.reportDetailModel?.sleepStructureModuleConfig?.includes('基本信息');
      
      return spo2HasBasicInfo || sleepHasBasicInfo;
    }
  },

  watch: {
    visible(newVal) {
      console.log('visible changed:', newVal);
      if (newVal) {
        this.loadPreviewData();
      }
    }
  },

  mounted() {
    console.log('BloodOxygenReportPreviewDialog mounted');
    console.log('visible prop:', this.visible);
    console.log('准备使用ES6动态import加载预览数据');
  },

  methods: {
    handleClose() {
      console.log('handleClose called');
      this.$emit('close');
    },

    async loadPreviewData() {
      console.log('loadPreviewData called');
      
      try {
        // 从OSS获取预览数据
        console.log('开始从OSS获取预览数据');
        
        const response = await this.$api.getBloodOxygenReportPreviewData();
        // 如果API返回的是response.data格式，直接使用；如果已经处理过，直接使用response
        const previewData = response;
        
        console.log('成功获取OSS预览数据:', previewData);
        console.log('检查reportDetail字段:', previewData?.reportDetail);
        console.log('检查reportUser字段:', previewData?.reportUser);
        
        if (!previewData) {
          throw new Error('OSS返回的预览数据为空');
        }
        
        if (!previewData.reportDetail) {
          throw new Error('OSS预览数据中缺少reportDetail字段');
        }
        
        if (!previewData.reportUser) {
          throw new Error('OSS预览数据中缺少reportUser字段');
        }
        
        console.log('开始创建ReportDetailModel');
        
        // 检查必要的全局函数是否可用
        if (typeof window.placeholderText !== 'function') {
          console.warn('placeholderText函数不可用，尝试定义备用函数');
          window.placeholderText = function(rawValue, unitText = "") {
            if (!rawValue) {
              return "-";
            } else {
              const finalUnitText = unitText ? ` ${unitText}` : "";
              return `${rawValue}${finalUnitText}`;
            }
          };
        }
        
        // 检查findKey函数是否可用
        if (typeof window.findKey !== 'function') {
          console.warn('findKey函数不可用，尝试定义备用函数');
          window.findKey = function(obj, value, compare = (a, b) => a === b) {
            return Object.keys(obj).find((k) => compare(obj[k], value));
          };
        }
        
        const reportDetailModel = new ReportDetailModel(previewData);
        
        // 使用传入的配置数据覆盖相应字段
        if (this.configData && Object.keys(this.configData).length > 0) {
          console.log('configData:', this.configData);
          console.log('使用配置数据覆盖字段:', this.configData);
          
          if (this.configData.sopReportLogo) {
            reportDetailModel.sopReportLogo = this.configData.sopReportLogo;
          }
          
          if (this.configData.sopReportHeaders) {
            reportDetailModel.sopReportHeaders = this.configData.sopReportHeaders;
          }
          
          if (this.configData.sopReportSubTitle) {
            reportDetailModel.sopReportSubTitle = this.configData.sopReportSubTitle;
          }
          
          // 添加模块配置的覆盖
          if (this.configData.sleepStructureModuleConfig) {
            reportDetailModel.sleepStructureModuleConfig = this.configData.sleepStructureModuleConfig;
          }
          
          if (this.configData.spo2PulseModuleConfig) {
            reportDetailModel.spo2PulseModuleConfig = this.configData.spo2PulseModuleConfig;
          }
          
         
        }
        
        this.reportDetailModel = reportDetailModel;
        console.log('ReportDetailModel创建完成:', this.reportDetailModel);
        
        // 如果是打印模式，等待DOM更新后自动打印
        if (this.isPrintMode) {
          console.log('打印模式，准备自动打印');
          this.$nextTick(() => {
            setTimeout(() => {
              window.print();
            }, 1000); // 延迟1秒确保所有内容都已渲染
          });
        }
      } catch (error) {
        console.error('从OSS获取预览数据或创建ReportDetailModel失败:', error);
        console.error('错误堆栈:', error.stack);
        this.$toast?.showRed("预览数据加载失败: " + error.message);
      }
    },

    onDownloadPNG() {
      this.$toast?.showRed("预览模式下不支持下载PNG");
      return;
    },

    async onDownloadPDF() {
      this.$toast?.showRed("预览模式下不支持下载PDF");
      return;
    },

    async onPrint() {
      this.$toast?.showRed("预览模式下不支持打印");
      return;
    },

    async onShare() {
      this.$toast?.showRed("预览模式下不支持分享");
      return;
    },

    async onEditSuggestionSucceed() {
      this.$toast?.showGreen("编辑成功");
      // 预览模式下不重新加载数据
    },

    async onEditUserInfoSucceed() {
      this.$toast?.showGreen("编辑成功");
      // 预览模式下不重新加载数据
    },

    useClassWithDifferentBrower() {
      //为了控制打印三页睡眠初筛报告，测试了五个浏览器FireFox，Chrome，Edge，Opera，Safari，只有Safari异常，所以添加这个方法调整css。
      const browserType = deviceTool.getBrowserType()
      if (browserType === 'Safari') {
        return 'single-blood-oxygen-report-button-container-Safari-no-print'
      } else {
        return ''
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.blood-oxygen-report-preview-dialog {
  ::v-deep .el-dialog {
    border-radius: 8px;
  }
  
  ::v-deep .el-dialog__body {
    padding: 20px;
    max-height: 80vh;
    overflow-y: auto;
  }
}

.single-blood-oxygen-report {
  width: 1050px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 20px 40px 10px;
  
  .single-blood-oxygen-report-section-chart{
    display: flex;
    justify-content: space-between;
  }

  &-logo {
    height: 66px;
    width: 66px;
    position: absolute;
  }

  &-title {
    color: black;
    font-size: 24px;
    font-weight: 600;
    height: 24px;
    display: flex;
    justify-content: center;
  }

  &-subtitle {
    color: black;
    font-size: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    margin-top: 5px;
  }

  &-button-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 44px;
    margin-bottom: 30px;

    &-item {
      color: white;
      background-color: #325FAC;
      border-radius: 4px;
      width: 88px;
      height: 32px;
      margin-left: 20px;
      border: none;
      cursor: pointer;
      
      &:disabled {
        background-color: #ccc;
        color: #666;
        cursor: not-allowed;
        opacity: 0.6;
      }
      
      &:hover:not(:disabled) {
        background-color: #2a4d8a;
      }
    }
  }

  &-section-title {
    color: black;
    font-size: 24px;
    font-weight: 600;
    line-height: 73px;
    width: 100%;
  }

  &-section {
    display: flex;
  }

  // 打印页眉 - 默认隐藏
  .print-header {
    display: none;
  }

  // 屏幕显示的头部信息 - 默认显示
  .screen-header {
    display: block;
    position: relative;
  }
}

.loading-content {
  text-align: center;
  padding: 50px;
  color: #666;
  font-size: 16px;
}

@media print {
  @page {
    size: A4;
    margin: 10mm;
  }
  
  .single-blood-oxygen-report {
    width: 100% !important;
    max-width: none !important;
    padding: 20px 0px 10px !important;
    
    .print-header {
      display: block !important;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      background: white;
      z-index: 1000;
      padding: 15px 0 20px !important;
    }

    .screen-header {
      display: none !important;
    }

    .print-page-1 {
      margin-top: 200px !important;
      page-break-after: always !important;
      break-after: page !important;
      min-height: 80vh !important;
    }
    
    .print-page-2 {
      margin-top: 220px !important;
      width: 100% !important;
      box-sizing: border-box !important;
    }
    
    .first-content-section {
      margin-top: 0 !important;
    }
    
    .sleep-content-section {
      margin-top: 0 !important;
      width: 100% !important;
    }
    
    .single-blood-oxygen-report-section-chart {
      display: flex !important;
      justify-content: space-between !important;
      width: 100% !important;
      box-sizing: border-box !important;
      gap: 5px !important;
      
      > * {
        flex: 1 !important;
        max-width: 49% !important;
        min-width: 0 !important;
      }
    }
  }

  ::v-deep .sleep-pie-chart {
    width: 100% !important;
    min-width: 260px !important;
    height: 220px !important;
  }

  .single-blood-oxygen-report-button-container-Safari-no-print {
    height: 40px;
    margin: 0px;
  }

  .noPrint {
    background-color: white !important;
  }
}
</style> 